import { useMeetingPlayer } from "../../MeetingPlayerContext"
import { SeekIcon } from "../SeekIcon"
import type { IProps } from "./interfaces"

/**
 * Binds a fragment chip to the single recording player. Each summary point
 * (decision, action item, open question, quote) renders one of these with its
 * resolved `seekTime`; the chip then plays/pauses + rewinds that moment in the
 * shared player. Renders nothing when no player is mounted (no recording) or no
 * segment matched the point.
 */
export function SeekControl({ seekTime }: IProps): React.JSX.Element | null {
  const player = useMeetingPlayer()
  if (!player.available || seekTime === null) return null
  const active = player.activeSeekTime === seekTime
  return (
    <SeekIcon
      seekTime={seekTime}
      active={active}
      playing={player.playing}
      onPlayPause={() => (active && player.playing ? player.pause() : player.play(seekTime))}
      onRewind={() => player.rewind(seekTime)}
    />
  )
}
